var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-screen-container',{staticClass:"report_container"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"left-top"},[_c('el-card',{staticClass:"card",staticStyle:{"min-width":"380px"},attrs:{"body-style":{padding:'0 10px',height:'610px'}}},[_c('user-info'),_c('user-todo')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }